import axios from 'axios'

const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/',
    timeout: 5000
})

// 请求拦截器

service.interceptors.request.use(
    config => {
        // 添加请求头等前置处理
        // config.headers['Authorization'] = 'Bearer' + ' ' + localStorage.getItem('token')
        let token = localStorage.getItem('Admin-Token')
        if (token) {
            token = JSON.parse(token).data
        }
        config.headers['Admin-Token'] = token
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
        return config
    },
    error => {
        // 请求错误处理
        // console.log('Request Error:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 响应后处理
        if (response.status === 200 && response.data.code === 0) {
            return Promise.resolve(response.data)
        } else {
            return Promise.reject(response.data)
        }
    },
    error => {
        // console.log('Response Error:', error)
        return Promise.reject(error)
    }
)

export default service